export default "__VITE_ASSET__6dddf837__"